module.exports = __webpack_public_path__ + "static/media/favicon.ef8eaa97.pdf";